<template>
  <div>
    <b-card>
      <div class="d-lg-flex">
        <!-- SNMP COMMUNITY LIST START -->
        <section name="snmp" class="col-12 col-lg-6 mb-1 mb-lg-0 py-1">
          <div class="list__container">
            <header
              class="padding__x mt-1 d-flex flex-wrap justify-content-between align-items-center w-100"
            >
              <label class="text__header mr-1">SNMP Community List</label>
              <atom-button
                v-if="hasUpdatePermission"
                buttonId="button-create-alert"
                buttonStyle="border"
                @click="clickButtonAddCommunity"
                ><div class="mb-0 width__button-add">Add New Community</div>
              </atom-button>
            </header>
            <main class="sub-list__container mt-2">
              <div v-if="communityListCount">
                <div
                  v-for="(community, index) in communityList"
                  :key="index"
                  class="card-list__container mb-1 p-1"
                  @click="clickCommunityRow(community.id)"
                >
                  <div
                    class="d-flex flex-wrap justify-content-between align-items-center w-100"
                  >
                    <label class="text__name pr-1">{{ community.name }}</label>
                    <label class="text__port">{{
                      `Port: ${community.port}`
                    }}</label>
                  </div>
                  <label
                    v-if="community.description"
                    class="text__description"
                    >{{ community.description }}</label
                  >
                </div>
              </div>
              <div v-else class="text-center">
                <label class="text__no-data">No SNMP Community Data.</label>
              </div>
            </main>

            <footer
              v-if="communityListCount"
              class="padding__x my-1 d-flex flex-wrap justify-content-between align-items-center w-100"
            >
              <label class="text__pagination"
                >Showing {{ communityList.length }} entries</label
              >
              <b-pagination
                v-model="communityCurrentPage"
                :total-rows="communityListCount"
                :per-page="perPage"
                size="sm"
                class="my-0"
              ></b-pagination>
            </footer>
          </div>
        </section>
        <!-- SNMP COMMUNITY LIST END -->

        <!-- SSH CREDENTIAL LIST START -->
        <section name="ssh" class="col-12 col-lg-6 py-1">
          <div class="list__container">
            <header
              class="padding__x mt-1 d-flex flex-wrap justify-content-between align-items-center w-100"
            >
              <label class="text__header mr-1">SSH Credential List</label>
              <atom-button
                v-if="hasUpdatePermission"
                buttonId="button-create-alert"
                buttonStyle="border"
                @click="clickButtonAddCredential"
                ><div class="width__button-add">Add New Credentials</div>
              </atom-button>
            </header>
            <main class="sub-list__container mt-2">
              <div v-if="credentialListCount">
                <div
                  v-for="(credential, index) in credentialList"
                  :key="index"
                  class="card-list__container mb-1 p-1"
                  @click="clickCredentialRow(credential.id)"
                >
                  <div
                    class="d-flex flex-wrap justify-content-between align-items-center w-100"
                  >
                    <label class="text__name pr-1">{{
                      `${credential.name} (${
                        credential.type === "SSH_V2" ? "SSH V2" : "TELNET"
                      })`
                    }}</label>
                    <label class="text__port">{{
                      `Port: ${credential.port}`
                    }}</label>
                  </div>
                  <label
                    v-if="credential.description"
                    class="text__description"
                    >{{ credential.description }}</label
                  >
                </div>
              </div>
              <div v-else class="text-center">
                <label class="text__no-data">No SSH Credential Data.</label>
              </div>
            </main>
            <footer
              v-if="credentialListCount"
              class="padding__x my-1 d-flex flex-wrap justify-content-between align-items-center w-100"
            >
              <label class="text__pagination"
                >Showing {{ credentialList.length }} entries</label
              >
              <b-pagination
                v-model="credentialCurrentPage"
                :total-rows="credentialListCount"
                :per-page="perPage"
                size="sm"
                class="my-0"
              ></b-pagination>
            </footer>
          </div>
        </section>
        <!-- SSH CREDENTIAL LIST END -->
      </div>
    </b-card>

    <!-- EDIT SNMP COMMUNITY START -->
    <section name="edit-community">
      <molecule-modal-dialog
        modalId="credential__edit-community"
        :isTextCenter="true"
        textTitle="Edit SNMP Community"
        buttonTextLeft="Save Change"
        :isSlotBody="true"
        :isButtonDelete="true && hasUpdatePermission"
        :isDisableButtonLeft="isDisableButtonEditCommunity"
        :isButtonLeft="hasUpdatePermission"
        :isButtonRight="hasUpdatePermission"
        classButton="px-2 pb-2"
        @clickButtonLeft="clickEditCommunity"
        @clickButtonRight="clickCancelEditCommunity"
        @clickButtonDelete="clickDeleteCommunity"
      >
        <template #body>
          <div class="w-100 p-2">
            <div class="row">
              <div class="col-8">
                <atom-input
                  v-model="editCommunity.name"
                  title="SNMP Name"
                  placeholder="SNMP Name"
                  :isAsterisk="true"
                  :isError="isErrorCommunityInput.name"
                  errorMessage="Please enter name"
                  :isDisable="!hasUpdatePermission"
                ></atom-input>
              </div>

              <div class="col-4 pl-1">
                <atom-input
                  v-model="editCommunity.port"
                  title="Port"
                  placeholder="Port"
                  :isAsterisk="true"
                  :isError="isErrorCommunityInput.port"
                  :errorMessage="`${
                    !editCommunity.port ? 'Port require' : 'Port invalid'
                  }`"
                  type="number"
                  :isDisable="!hasUpdatePermission"
                ></atom-input>
              </div>
            </div>

            <atom-text-area
              v-model="editCommunity.description"
              title="Description"
              placeholder="SNMP Description"
              :rows="3"
              :isDisable="!hasUpdatePermission"
              class="mt-1"
            ></atom-text-area>

            <atom-input
              v-model="editCommunity.communityString"
              title="Community String"
              placeholder="Community String"
              :isAsterisk="true"
              :isError="isErrorCommunityInput.communityString"
              errorMessage="Please enter community string"
              :isDisable="!hasUpdatePermission"
              class="mt-1"
            ></atom-input>
          </div>
        </template>
      </molecule-modal-dialog>

      <section name="modal-confirm-edit-community">
        <molecule-modal-dialog
          modalId="credential__confirm-edit-community"
          :isTextCenter="true"
          :textTitle="`Do you want to add\n“${editCommunity.name}” ?`"
          buttonTextLeft="Confirm"
          @clickButtonLeft="clickConfirmEditCommunity"
          @clickButtonRight="clickBackToModalEditCommunity"
        ></molecule-modal-dialog>
        <molecule-modal-dialog
          modalId="credential__confirm-cancel-edit-community"
          :isTextCenter="true"
          :textTitle="`Do you want to leave\nwithout finishing?`"
          buttonTextLeft="Confirm"
          :isCloseModal="false"
          @clickButtonLeft="clickConfirmCancelAddEditCommunity"
          @clickButtonRight="clickBackToModalEditCommunity"
        ></molecule-modal-dialog>
      </section>

      <section name="modal-confirm-delete-community">
        <molecule-modal-dialog
          modalId="credential__confirm-delete-community"
          :isTextCenter="true"
          :textTitle="`Do you want to delete\n“${editCommunity.name}” ?`"
          buttonTextLeft="Delete"
          buttonColorLeft="danger"
          @clickButtonLeft="clickConfirmDeleteCommunity"
        ></molecule-modal-dialog>
      </section>
    </section>
    <!-- EDIT SNMP COMMUNITY END -->

    <!-- EDIT SSH CREDENTIALS START -->
    <section name="edit-credential">
      <molecule-modal-dialog
        modalId="credential__edit-credential"
        :isTextCenter="true"
        textTitle="Edit SSH Credentials"
        buttonTextLeft="Save Change"
        :isSlotBody="true"
        :isButtonDelete="true && hasUpdatePermission"
        :isDisableButtonLeft="isDisableButtonEditCredential"
        :isButtonLeft="hasUpdatePermission"
        :isButtonRight="hasUpdatePermission"
        classButton="px-2 pb-2"
        @clickButtonLeft="clickEditCredential"
        @clickButtonRight="clickCancelEditCredential"
        @clickButtonDelete="clickDeleteCredential"
      >
        <template #body>
          <div class="w-100 p-2 body__height">
            <div class="row">
              <div class="col-8">
                <atom-input
                  v-model="editCredential.name"
                  title="Credential Name"
                  placeholder="Credential Name"
                  :isAsterisk="true"
                  :isError="isErrorCredentialInput.name"
                  errorMessage="Please enter name"
                  :isDisable="!hasUpdatePermission"
                ></atom-input>
              </div>

              <div class="col-4 pl-1">
                <atom-input
                  v-model="editCredential.port"
                  title="Port"
                  placeholder="Port"
                  :isAsterisk="true"
                  :isError="isErrorCredentialInput.port"
                  type="number"
                  :isDisable="!hasUpdatePermission"
                ></atom-input>
              </div>
            </div>

            <atom-text-area
              v-model="editCredential.description"
              title="Description"
              placeholder="Credential Description"
              :rows="3"
              :isDisable="!hasUpdatePermission"
              class="mt-1"
            ></atom-text-area>

            <div class="mt-2">
              <div class="text__title">
                Resource Type<label v-if="hasUpdatePermission" class="text__asterisk">*</label>
              </div>
              <div class="d-flex">
                <molecule-radio-select-data
                  v-for="(option, index) in resourceTypeOptions"
                  :key="index"
                  :radioOption="option"
                  :isAsterisk="true"
                  :selectedRadio="editCredential.type"
                  :canUpdate="hasUpdatePermission"
                  @selected="selectedType"
                >
                </molecule-radio-select-data>
              </div>
            </div>

            <atom-input
              v-model="editCredential.username"
              title="Username"
              placeholder="Username"
              :isAsterisk="true"
              :isError="isErrorCredentialInput.username"
              :isDisable="!hasUpdatePermission"
              class="mt-2"
            ></atom-input>

            <atom-input
              v-model="editCredential.password"
              title="Password"
              placeholder="Leave blank to keep the old password."
              :isAsterisk="false"
              :isError="isErrorCredentialInput.password"
              type="password"
              :isDisable="!hasUpdatePermission"
              class="mt-1"
            ></atom-input>

            <atom-input
              v-model="editCredential.prompt"
              title="Prompt"
              placeholder=">"
              :isAsterisk="true"
              :isError="isErrorCredentialInput.prompt"
              :isDisable="!hasUpdatePermission"
              class="mt-1"
            ></atom-input>

            <div class="d-flex justify-content-end mt-2">
              <atom-switch
                v-model="editCredential.isEnableRequired"
                title="Enable Required"
                :isDisable="!hasUpdatePermission"
              ></atom-switch>
            </div>

            <div v-if="editCredential.isEnableRequired">
              <atom-input
                v-model="editCredential.enableCommand"
                title="Enable Command"
                placeholder="enable"
                :isDisable="!hasUpdatePermission"
                class="mt-1"
              ></atom-input>

              <atom-input
                v-model="editCredential.enablePrompt"
                title="Enable Prompt"
                placeholder="#"
                :isDisable="!hasUpdatePermission"
                class="mt-1"
              ></atom-input>

              <atom-input
                v-model="editCredential.enablePassword"
                title="Enable Password"
                placeholder="Leave blank to keep the old enable password."
                type="password"
                :isDisable="!hasUpdatePermission"
                class="mt-1"
              ></atom-input>
            </div>

          </div>
        </template>
      </molecule-modal-dialog>

      <section name="modal-confirm-edit-credential">
        <molecule-modal-dialog
          modalId="credential__confirm-edit-credential"
          :isTextCenter="true"
          :textTitle="`Do you want to edit\n“${editCredential.name}” ?`"
          buttonTextLeft="Confirm"
          @clickButtonLeft="clickConfirmEditCredential"
          @clickButtonRight="clickBackToModalEditCredential"
        ></molecule-modal-dialog>
        <molecule-modal-dialog
          modalId="credential__confirm-cancel-edit-credential"
          :isTextCenter="true"
          :textTitle="`Do you want to leave\nwithout finishing?`"
          buttonTextLeft="Confirm"
          :isCloseModal="false"
          @clickButtonLeft="clickConfirmCancelAddEditCredential"
          @clickButtonRight="clickBackToModalEditCredential"
        ></molecule-modal-dialog>
      </section>

      <section name="modal-confirm-delete-credential">
        <molecule-modal-dialog
          modalId="credential__confirm-delete-credential"
          :isTextCenter="true"
          :textTitle="`Do you want to delete\n“${editCredential.name}” ?`"
          buttonTextLeft="Delete"
          buttonColorLeft="danger"
          @clickButtonLeft="clickConfirmDeleteCredential"
        ></molecule-modal-dialog>
      </section>
    </section>
    <!-- EDIT SSH CREDENTIALS END -->
  </div>
</template>

<script>
import { BCard, BPagination } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeRadioSelectData from "@/components/molecules/MoleculeRadioSelectData.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismCredential",
  components: {
    BCard,
    BPagination,
    AtomButton,
    MoleculeModalDialog,
    AtomInput,
    AtomTextArea,
    MoleculeRadioSelectData,
    AtomSwitch,
  },
  mixins: [mixinsUser],
  props: {
    communityListCount: {
      type: Number,
      required: true,
    },
    communityList: {
      type: Array,
      required: true,
    },
    credentialListCount: {
      type: Number,
      required: true,
    },
    credentialList: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      required: false,
      default: 5,
    },

    communityDetail: {
      type: Object,
      required: false,
      default: null,
    },
    credentialDetail: {
      type: Object | null,
      required: false,
      default: null,
    },
  },
  emits: [
    "communityCurrentPageChange",
    "credentialCurrentPageChange",
    "clickButtonAddCommunity",
    "clickButtonAddCredential",
    "clickCommunityRow",
    "clickCredentialRow",
    "editCommunity",
    "editCredential",
    "deleteCommunityById",
    "deleteCredentialById",
  ],
  data() {
    return {
      modalId: null,

      /* COMMUNITY START */
      communityCurrentPage: 1,

      editCommunity: {
        name: null,
        port: "161",
        description: "",
        communityString: null,
      },
      isValidateCommunity: false,
      isErrorCommunityInput: {
        name: false,
        port: false,
        communityString: false,
      },
      /* COMMUNITY END */

      /* CREDENTIAL START */
      credentialCurrentPage: 1,

      resourceTypeOptions: [
        {
          id: "SSH_V2",
          topic: "SSH V2",
        },
        {
          id: "TELNET",
          topic: "Telnet",
        },
      ],
      editCredential: {
        name: null,
        port: "22",
        description: "",
        type: null,
        username: null,
        password: null,
        prompt: null,
        isEnableRequired: false,
        enableCommand: null,
        enablePrompt: null,
        enablePassword: null,
      },
      isValidateCredential: false,
      isErrorCredentialInput: {
        name: false,
        port: false,
        username: false,
        password: false,
        prompt: false,
      },
      /* CREDENTIAL END */
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.NCM.CREDENTIAL_WRITE)
    },

    /* COMMUNITY START */
    isErrorCommunity() {
      return (
        this.isValidateCommunity &&
        (this.isErrorCommunityInput.name ||
          this.isErrorCommunityInput.port ||
          this.isErrorCommunityInput.communityString)
      )
    },
    isDisableButtonEditCommunity() {
      return this.isValidateCommunity && this.isErrorCommunity
    },
    /* COMMUNITY END */

    /* CREDENTIAL START */
    isErrorCredential() {
      return (
        this.isValidateCredential &&
        (this.isErrorCredentialInput.name ||
          this.isErrorCredentialInput.port ||
          this.isErrorCredentialInput.password ||
          this.isErrorCredentialInput.prompt)
      )
    },
    isDisableButtonEditCredential() {
      return this.isValidateCredential && this.isErrorCredential
    },
    /* CREDENTIAL END */
  },
  watch: {
    communityCurrentPage: {
      handler() {
        this.$emit("communityCurrentPageChange", {
          PageNumber: this.communityCurrentPage,
        })
      },
    },
    credentialCurrentPage: {
      handler() {
        this.$emit("credentialCurrentPageChange", {
          PageNumber: this.credentialCurrentPage,
        })
      },
    },

    communityDetail: {
      deep: true,
      handler() {
        if (this.communityDetail)
          this.editCommunity = JSON.parse(JSON.stringify(this.communityDetail))
      },
    },
    credentialDetail: {
      deep: true,
      handler() {
        if (this.credentialDetail)
          this.editCredential = {
            ...JSON.parse(JSON.stringify(this.credentialDetail)),
            type: this.resourceTypeOptions.find(
              (t) => t.id === this.credentialDetail.type
            ),
          }
      },
    },
    editCommunity: {
      deep: true,
      handler() {
        if (this.isValidateCommunity) this.validateEditCommunity()
      },
    },
    editCredential: {
      deep: true,
      handler() {
        if (this.isValidateCredential) this.validateEditCredential()

        if (this.editCredential.type)
          this.editCredential.port =
            this.editCredential.type.id === "SSH_V2" ? 22 : 23
      },
    },
  },
  mounted() {
    if (this.communityDetail)
      this.editCommunity = JSON.parse(JSON.stringify(this.communityDetail))

    if (this.credentialDetail)
      this.editCredential = {
        ...JSON.parse(JSON.stringify(this.credentialDetail)),
        type: this.resourceTypeOptions.find(
          (t) => t.id === this.credentialDetail.type
        ),
      }
  },
  methods: {
    /* COMMUNITY START */
    clickButtonAddCommunity() {
      this.$emit("clickButtonAddCommunity")
    },
    clickCommunityRow(id) {
      this.$emit("clickCommunityRow", id)
    },

    clickEditCommunity() {
      this.isValidateCommunity = true
      this.validateEditCommunity()

      if (!this.isErrorCommunity) {
        this.closeModal("credential__edit-community")
        this.openModal("credential__confirm-edit-community")
      }
    },
    clickConfirmEditCommunity() {
      const editCommunity = {
        credentialName: this.editCommunity.name,
        credentialDescription: this.editCommunity.description,
        communityString: this.editCommunity.communityString,
        port: this.editCommunity.port,
      }

      this.$emit("editCommunity", this.editCommunity.id, editCommunity)

      this.closeModal()
      this.setEditCommunityToOrigin()
    },
    clickCancelEditCommunity() {
      this.closeModal("credential__edit-community")
      this.openModal("credential__confirm-cancel-edit-community")
    },
    clickBackToModalEditCommunity() {
      this.closeModal()
      this.openModal("credential__edit-community")
    },
    clickConfirmCancelAddEditCommunity() {
      this.closeModal()
      this.setEditCommunityToOrigin()
    },
    setEditCommunityToOrigin() {
      this.editCommunity = {
        name: null,
        port: "161",
        description: "",
        communityString: null,
      }
      this.isValidateCommunity = false
      this.isErrorCommunityInput = {
        name: false,
        port: false,
        communityString: false,
      }
    },
    validateEditCommunity() {
      this.isErrorCommunityInput = this.validateCommunity(this.editCommunity)
    },
    clickDeleteCommunity() {
      this.closeModal("credential__edit-community")
      this.openModal("credential__confirm-delete-community")
    },
    clickConfirmDeleteCommunity() {
      this.$emit("deleteCommunityById", this.editCommunity.id)

      this.closeModal()
    },
    /* COMMUNITY END */

    /* CREDENTIAL START */
    clickButtonAddCredential() {
      this.$emit("clickButtonAddCredential")
    },
    clickCredentialRow(id) {
      this.$emit("clickCredentialRow", id)
    },

    selectedType(type) {
      this.editCredential.type = type
    },
    clickEditCredential() {
      this.isValidateCredential = true
      this.validateEditCredential()

      if (!this.isErrorCredential) {
        this.closeModal("credential__edit-credential")
        this.openModal("credential__confirm-edit-credential")
      }
    },
    clickConfirmEditCredential() {
      const editCredential = {
        credentialName: this.editCredential.name,
        credentialProtocol: this.editCredential.type.id,
        credentialDescription: this.editCredential.description,
        username: this.editCredential.username,
        password: this.editCredential.password,
        prompt: this.editCredential.prompt,
        enableRequired: this.editCredential.isEnableRequired,
        enableCommand: this.editCredential.enableCommand,
        enablePrompt: this.editCredential.enablePrompt,
        enablePassword: this.editCredential.enablePassword,
        port: this.editCredential.port,
      }

      this.$emit("editCredential", this.editCredential.id, editCredential)

      this.closeModal()
      this.setEditCredentialToOrigin()
    },
    clickCancelEditCredential() {
      this.closeModal("credential__edit-credential")
      this.openModal("credential__confirm-cancel-edit-credential")
    },
    clickBackToModalEditCredential() {
      this.closeModal()
      this.openModal("credential__edit-credential")
    },
    clickConfirmCancelAddEditCredential() {
      this.closeModal()
      this.setEditCredentialToOrigin()
    },
    setEditCredentialToOrigin() {
      this.editCredential = {
        name: null,
        port: "161",
        description: "",
        type: this.resourceTypeOptions[0],
        username: null,
        password: null,
        prompt: null,
        isEnableRequired: false,
        enableCommand: null,
        enablePrompt: null,
        enablePassword: null,
      }
      this.isValidateCredential = false
      this.isErrorCredentialInput = {
        name: false,
        port: false,
        description: false,
      }
    },
    validateEditCredential() {
      this.isErrorCredentialInput = this.validateCredential(this.editCredential)
    },
    clickDeleteCredential() {
      this.closeModal("credential__edit-credential")
      this.openModal("credential__confirm-delete-credential")
    },
    clickConfirmDeleteCredential() {
      this.$emit("deleteCredentialById", this.editCredential.id)

      this.closeModal()
    },
    /* CREDENTIAL END */

    /* MODAL START */
    openModal(id) {
      if (this.modalId) this.closeModal()

      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    closeModal(id) {
      if (!id) id = this.modalId

      this.$bvModal.hide(id)
      this.modalId = null
    },
    /* MODAL END */

    /* VALIDATE START */
    validateCommunity({ name, port, communityString }) {
      return {
        name: this.checkEmptyString(name),
        port: this.checkRegExPort(port),
        communityString: this.checkEmptyString(communityString),
      }
    },

    validateCredential({ name, port, username, password, prompt }) {
      return {
        name: this.checkEmptyString(name),
        port: this.checkRegExPort(port),
        username: this.checkEmptyString(username),
        // password: this.checkEmptyString(password),
        prompt: this.checkEmptyString(prompt),
      }
    },

    checkEmptyString(string) {
      return !string
    },
    checkRegExPort(port) {
      return !/^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(
        port
      )
    },
    /* VALIDATE END */
  },
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 1rem;
}

.list__container {
  border: 1px solid #b9b9c3;
  border-radius: 6px;
}

.sub-list__container {
  max-height: calc(100vh - 27rem);
  padding: 0 1.5rem;
  overflow-y: auto;
}

.card-list__container {
  background: rgba(0, 0, 0, 0.0001);
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  cursor: pointer;
}

.width__button-add {
  width: 155px;
}

.text__header {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.text__no-data {
  color: #5e5873;
  font-weight: 500;
  font-size: 14px;
}

.text__pagination {
  color: #82868b;
  font-size: 14px;
}

.text__name {
  color: #5e5873;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #7367f0;
  }
}

.text__port {
  color: #5e5873;
  font-weight: 500;
  font-size: 14px;
  cursor: auto;
}

.text__description {
  color: #5e5873;
  font-weight: 300;
  font-size: 12px;
  cursor: auto;
}

.padding__x {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.text__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.text__asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.body__height {
  max-height: calc(100vh - 20rem);
  overflow-y: auto;
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .list__container {
    height: calc(100vh - 17rem);
    max-height: calc(100vh - 17rem);
  }
}
</style>
